import { Toast } from "components"
import { postCreateReference, postProccessPayment } from "./api"
import { IPay } from "./props"

export const registerReference = async (
  setLoading: Function,
  setCreateReference: Function,
) => {
  try {
    setLoading(true)

    const response = await postCreateReference()

    if (response?.response !== 'success') {
      throw new Error(response?.response || 'Error al enviar los datos, intente nuevamente')
    }

    setCreateReference(response)
  } catch (error: any) {
    Toast({
      type: 'error',
      message: error.message === 'Load failed' ? 'Intente nuevamente' : error.message
    })
  } finally {
    setLoading(false)
  }
}

export const processPayment = async (
  data: IPay,
  setStep: Function,
  setResult: Function,
) => {
  try {
    const response = await postProccessPayment({
      ...data,
      description: 'Test vocacional automático',
    })

    if (response?.response !== 'success') {
      throw new Error(response?.response || 'Error al enviar los datos, intente nuevamente')
    }

    setStep(2)
    setResult(response?.result)
} catch (error: any) {
    Toast({
      type: 'error',
      message: error.message === 'Load failed' ? 'Intente nuevamente' : error.message
    })
  }
}